import React from 'react';
import { motion } from 'framer-motion';
const coachNeeds = ['More structure.', 'More clarity.', 'More visual references.', 'A faster way to recognize technical errors.', 'A clearer way to explain difficult positions.', 'A better way to select the next progression.', 'And a ready-to-use system for turning coaching knowledge into organized sessions.'];
const alreadyHave = ['You already have the visual framework.', 'You already have the technical progression.', 'You already have the correction system.', 'You already have the drills.', 'You already have the athlete-development structure.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-amber-500/30" data-id="element-49" data-mp="13ox8qanfszfj">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-50" data-mp="13onjwqe4oybf">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-blue-950 mb-6" data-id="element-51" data-mp="24vcut3jcpt6p">
          What Olympic Weightlifting coaches are looking for is not more information.
        </h2>
        <p className="text-xl text-blue-950/75 mb-4" data-id="element-52" data-mp="1v6betdct3bsq">
          There are already thousands of videos, posts, drills and training ideas available.
        </p>
        <p className="text-xl text-blue-950/75 mb-8" data-id="element-53" data-mp="202rz1wgvx60j">
          <span className="text-amber-600 font-semibold" data-id="element-54" data-mp="1l6khl3wv2ioy">
            The real challenge is turning all that information into a system you can actually use.
          </span>
        </p>

        <p className="text-lg text-blue-950 font-semibold mb-3" data-id="element-55" data-mp="1c7gvrs6b7p6r">What coaches need is:</p>
        <ul className="text-lg text-slate-700 space-y-1 mb-10" data-id="element-56" data-mp="1h5qrq4zuyttf">
          {coachNeeds.map(need => <li key={need} data-id="element-57" data-mp="36kf6udzu2pv5">{need}</li>)}
        </ul>

        <div className="bg-white border border-amber-500/40 rounded-2xl p-8 shadow-sm shadow-blue-700/10 text-lg text-slate-700 space-y-2" data-id="element-58" data-mp="36ivmocb23uo3">
          <p data-id="element-59" data-mp="395weymlt1q3c">
            With Olympic Weightlifting Coach Ready, you do not have to begin every training session
            from an empty page.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-blue-950 font-semibold" data-id="element-60" data-mp="303wufkbl03vn">
              {line}
            </p>)}
          <p className="text-blue-950 font-semibold" data-id="element-61" data-mp="2v6n5e5s3tu8c">
            And with 150 ready-to-coach sessions, you already have the session.
          </p>
        </div>
      </motion.div>
    </section>;
}